(function () {
  function norm(s) {
    return (s || "")
      .replace(/\s+/g, " ")
      .trim()
      .toUpperCase();
  }

  function apply() {
    // Solo en header + drawers de menú (evita CTAs del contenido)
    var scopes = document.querySelectorAll("header, .menu-drawer, .drawer, #MobileMenu, .mobile-nav");

    scopes.forEach(function (scope) {
      scope.querySelectorAll("a").forEach(function (a) {
        var t = norm(a.textContent);
        if (t === "SALE" || t === "DESCUENTOS") {
          a.classList.add("is-sale-highlight");
        } else {
          a.classList.remove("is-sale-highlight");
        }
      });
    });
  }

  document.addEventListener("DOMContentLoaded", function () {
    apply();
    // El menú móvil se re-renderiza: observar cambios
    var obs = new MutationObserver(apply);
    obs.observe(document.documentElement, { childList: true, subtree: true });
  });
})();
